export default __webpack_public_path__ + "static/media/i111hp.fd54439f.webp";